<ng-container *ngIf="action$ | async as action">
    <p-button icon="pi pi-hidden" [label]="(label$ | async) ?? ''" [label]="action.description"
    ntapDebounceClick (onClick)="executeAction($event)"
        [disabled]="(isDisabled$ | async) ?? true" [pTooltip]="tooltip" tooltipPosition="left"></p-button>
</ng-container>